import { globalActor } from "../../state/GlobalContextProvider";

export default function Menu() {
  const send = ({ type }) => {
    globalActor.send({ type: "TOGGLE_MENU" });
    globalActor.send({ type });
  };
  return (
    <div className="Screen Menu">
      <div className="BG"></div>
      <div className="Buttons">
        <button
          className="Close"
          onClick={(_) => globalActor.send({ type: "TOGGLE_MENU" })}
        ></button>
        <h2>SKIP TO</h2>
        <ul>
          <li>
            <button
              onClick={(_) => {
                send({ type: "SKIP_TO_PRIME" });
              }}
            >
              PRIMING THE BOTTLE
            </button>
          </li>
          <li>
            <button
              onClick={(_) => {
                window.gaEvent({ event: "skip_to_drop_comparision_clicked" });
                send({ type: "SKIP_TO_DROP" });
              }}
            >
              DROP SIZE
            </button>
          </li>
          <li>
            <button
              onClick={(_) => {
                window.gaEvent({ event: "skip_to_blink_comparision_clicked" });
                send({ type: "SKIP_TO_BLINK" });
              }}
            >
              BLINK REFLEX
            </button>
          </li>
          <li>
            <button
              onClick={(_) => {
                send({ type: "SKIP_TO_WHAT_PATIENTS" });
              }}
            >
              WHAT PATIENTS SHOULD KNOW
            </button>
          </li>
          <li>
            <a
              href="https://www.bausch.com/globalassets/pdf/packageinserts/pharma/miebo-package-insert.pdf"
              target="_blank"
              onClick={(_) =>
                window.gaEvent({ event: "prescribe_information_clicked" })
              }
            >
              Prescribing Information
            </a>
          </li>
          <li>
            <a
              href="https://www.bausch.com/privacy/"
              target="_blank"
              onClick={(_) =>
                window.gaEvent({ event: "privacy_information_clicked" })
              }
            >
              Bausch + Lomb Privacy Policy
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
